import Activate from '@/views/Activate.vue';
import AdvertisingChannelList from '@/views/ClinicPanel/AdvertisingChannelList.vue';
import AppointmentBookingWidget from '@/views/ClinicPanel/AppointmentBookingWidget.vue';
import AppointmentScheduleCabinetMonth
  from '@/views/ClinicPanel/AppointmentScheduleCabinetMonth.vue';
import AppointmentScheduleCabinetPeriod
  from '@/views/ClinicPanel/AppointmentScheduleCabinetPeriod.vue';
import AppointmentScheduleCabinets from '@/views/ClinicPanel/AppointmentScheduleCabinets.vue';
import AppointmentScheduleEmployeeMonth
  from '@/views/ClinicPanel/AppointmentScheduleEmployeeMonth.vue';
import AppointmentScheduleEmployeePeriod
  from '@/views/ClinicPanel/AppointmentScheduleEmployeePeriod.vue';
import AppointmentScheduleEmployees from '@/views/ClinicPanel/AppointmentScheduleEmployees.vue';
import AppointmentSettings from '@/views/ClinicPanel/AppointmentSettings.vue';
import Auth from '@/views/Auth.vue';
import CabinetList from '@/views/ClinicPanel/CabinetList.vue';
import CallHistory from '@/views/ClinicPanel/CallHistory.vue';
import CashboxList from '@/views/ClinicPanel/CashboxList.vue';
import CashboxOnlineCheckOrManual from '@/views/ClinicPanel/CashboxOnlineCheckOrManual.vue';
import ChiefPhysicianVisit from '@/views/ClinicPanel/ChiefPhysicianVisit.vue';
import ChiefPhysicianVisitList from '@/views/ClinicPanel/ChiefPhysicianVisitList.vue';
import ClinicDocumentTemplateList from '@/views/ClinicPanel/ClinicDocumentTemplateList.vue';
import ClinicSettings from '@/views/ClinicPanel/ClinicSettings.vue';
import CrmDeal from '@/views/ClinicPanel/CrmDeal.vue';
import CrmFunnels from '@/views/ClinicPanel/CrmFunnels.vue';
import DiaryTemplateList from '@/views/ClinicPanel/DiaryTemplateList.vue';
import DocumentGenerations from '@/views/ClinicPanel/DocumentGenerations.vue';
import EmployeeActionHistories from '@/views/ClinicPanel/EmployeeActionHistories.vue';
import EmployeeList from '@/views/ClinicPanel/EmployeeList.vue';
import EmployeePayroll from '@/views/ClinicPanel/EmployeePayroll.vue';
import EmployeePayrollDetails from '@/views/ClinicPanel/EmployeePayrollDetails.vue';
import EmployeePayrollSchema from '@/views/ClinicPanel/EmployeePayrollSchema.vue';
import EmployeeProfileAdmission from '@/views/ClinicPanel/EmployeeProfileAdmission.vue';
import EmployeeProfileBasic from '@/views/ClinicPanel/EmployeeProfileBasic.vue';
import EmployeeProfileEgisz from '@/views/ClinicPanel/EmployeeProfileEgisz.vue';
import EmployeeProfilePermissions from '@/views/ClinicPanel/EmployeeProfilePermissions.vue';
import EmployeeProfileWorkPlace from '@/views/ClinicPanel/EmployeeProfileWorkPlace.vue';
import EmployeeRoleList from '@/views/ClinicPanel/EmployeeRoleList.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import FormEmployee from '@/views/ClinicPanel/FormEmployee.vue';
import FormPatient from '@/views/ClinicPanel/FormPatient.vue';
import Integration32top from '@/views/ClinicPanel/Integration32top.vue';
import IntegrationFDoc from '@/views/ClinicPanel/IntegrationFDoc.vue';
import IntegrationList from '@/views/ClinicPanel/IntegrationList.vue';
import IntegrationMangoOffice from '@/views/ClinicPanel/IntegrationMangoOffice.vue';
import IntegrationProdoctorov from '@/views/ClinicPanel/IntegrationProdoctorov.vue';
import IntegrationUis from '@/views/ClinicPanel/IntegrationUis.vue';
import MedcardMerging from '@/views/ClinicPanel/MedcardMerging.vue';
import NdflCertificate from '@/views/ClinicPanel/NdflCertificate.vue';
import NdflCertificateCreation from '@/views/ClinicPanel/NdflCertificateCreation.vue';
import NotificationList from '@/views/ClinicPanel/NotificationList.vue';
import NotificationPlans from '@/views/ClinicPanel/NotificationPlans.vue';
import PatientAdvanceDetailList from '@/views/ClinicPanel/PatientAdvanceDetailList.vue';
import PatientList from '@/views/ClinicPanel/PatientList.vue';
import PatientProfileAnamnesis from '@/views/ClinicPanel/PatientProfileAnamnesis.vue';
import PatientProfileAppointments from '@/views/ClinicPanel/PatientProfileAppointments.vue';
import PatientProfileBasic from '@/views/ClinicPanel/PatientProfileBasic.vue';
import PatientProfileDocuments from '@/views/ClinicPanel/PatientProfileDocuments.vue';
import PatientProfileHealthQuestionnaire
  from '@/views/ClinicPanel/PatientProfileHealthQuestionnaire.vue';
import PatientProfileInvoice from '@/views/ClinicPanel/PatientProfileInvoice.vue';
import PatientProfileInvoiceList from '@/views/ClinicPanel/PatientProfileInvoiceList.vue';
import PatientProfilePlan from '@/views/ClinicPanel/PatientProfilePlan.vue';
import PatientProfilePlanList from '@/views/ClinicPanel/PatientProfilePlanList.vue';
import PatientProfileSnapshots from '@/views/ClinicPanel/PatientProfileSnapshots.vue';
import PatientProfileVisit from '@/views/ClinicPanel/PatientProfileVisit.vue';
import PatientProfileVisits from '@/views/ClinicPanel/PatientProfileVisits.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';
import ProcessingPersonalData from '@/views/ProcessingPersonalData.vue';
import Registration from '@/views/Registration.vue';
import RegistryNdflCertificateList from '@/views/ClinicPanel/RegistryNdflCertificateList.vue';
import ReportDashboard from '@/views/ClinicPanel/ReportDashboard.vue';
import ReportDirectionsRevenue from '@/views/ClinicPanel/ReportDirectionsRevenue.vue';
import ReportEmployees from '@/views/ClinicPanel/ReportEmployees.vue';
import ReportEmployeesPayroll from '@/views/ClinicPanel/ReportEmployeesPayroll.vue';
import ReportEmployeesWorkload from '@/views/ClinicPanel/ReportEmployeesWorkload.vue';
import ReportPatientAttractingCost from '@/views/ClinicPanel/ReportPatientAttractingCost.vue';
import ReportPatientReturnRate from '@/views/ClinicPanel/ReportPatientReturnRate.vue';
import ReportPatientsAdministrators from '@/views/ClinicPanel/ReportPatientsAdministrators.vue';
import ReportSalesServices from '@/views/ClinicPanel/ReportSalesServices.vue';
import ReportSalesSources from '@/views/ClinicPanel/ReportSalesSources.vue';
import ReportServicesDms from '@/views/ClinicPanel/ReportServicesDms.vue';
import ReportTreatmentPlans from '@/views/ClinicPanel/ReportTreatmentPlans.vue';
import ReportWarehouseProductBalances from '@/views/ClinicPanel/ReportWarehouseProductBalances.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import ServicePriceList from '@/views/ClinicPanel/ServicePriceList.vue';
import Tariffs from '@/views/ClinicPanel/Tariffs.vue';
import TaskList from '@/views/ClinicPanel/TaskList.vue';
import TreatmentPlanTemplateList from '@/views/ClinicPanel/TreatmentPlanTemplateList.vue';
import UserProfile from '@/views/ClinicPanel/UserProfile.vue';
import WaitingList from '@/views/ClinicPanel/WaitingList.vue';
import WarehouseProductArrival from '@/views/ClinicPanel/WarehouseProductArrival.vue';
import WarehouseProductArrivalList from '@/views/ClinicPanel/WarehouseProductArrivalList.vue';
import WarehouseProductList from '@/views/ClinicPanel/WarehouseProductList.vue';
import WarehouseProductUnitList from '@/views/ClinicPanel/WarehouseProductUnitList.vue';
import WarehouseProductWriteOff from '@/views/ClinicPanel/WarehouseProductWriteOff.vue';
import WarehouseProductWriteOffList from '@/views/ClinicPanel/WarehouseProductWriteOffList.vue';
import WarehouseVendorList from '@/views/ClinicPanel/WarehouseVendorList.vue';
import Welcome from '@/views/ClinicPanel/Welcome.vue';
import WorkSchedule from '@/views/ClinicPanel/WorkSchedule.vue';
import WorkTimeAccountJournal from '@/views/ClinicPanel/WorkTimeAccountJournal.vue';
import {
  FORGOT_PASSWORD_FEATURE,
  isRemovedFeature,
  REGISTRATION_FEATURE,
} from '@/removableFeatures';
import { CLINIC_AUTH } from '@/store/modules/user';
import LoyaltySystemSettings from '@/views/ClinicPanel/LoyaltySystemSettings.vue';
import IntegrationChatPush from '@/views/ClinicPanel/IntegrationChatPush.vue';
import ReportCashboxes from '@/views/ClinicPanel/ReportCashboxes.vue';

/**
 * @description Список маршрутов для клиники.
 * @var {any[]}
 */
const clinicRoutes = [
  {
    component: AdvertisingChannelList,
    name: 'ClinicPanelAdvertisingChannelList',
    path: '/advertising-channels',
  },
  {
    component: AppointmentBookingWidget,
    name: 'ClinicPanelAppointmentBookingWidget',
    path: '/integrations/appointment-booking-widget',
  },
  {
    component: AppointmentScheduleCabinets,
    name: 'ClinicPanelAppointmentScheduleCabinets',
    path: '/appointment-schedule/cabinets',
    props: true,
  },
  {
    component: AppointmentScheduleCabinetPeriod,
    name: 'ClinicPanelAppointmentScheduleCabinetPeriod',
    path: '/appointment-schedule/cabinets/:id',
    props: true,
  },
  {
    component: AppointmentScheduleCabinetMonth,
    name: 'ClinicPanelAppointmentScheduleCabinetMonth',
    path: '/appointment-schedule/cabinets/:id/month/:month',
    props: true,
  },
  {
    component: AppointmentScheduleEmployees,
    name: 'ClinicPanelAppointmentScheduleEmployees',
    path: '/appointment-schedule/employees',
    props: true,
  },
  {
    component: AppointmentScheduleEmployeePeriod,
    name: 'ClinicPanelAppointmentScheduleEmployeePeriod',
    path: '/appointment-schedule/employees/:id',
    props: true,
  },
  {
    component: AppointmentScheduleEmployeeMonth,
    name: 'ClinicPanelAppointmentScheduleEmployeeMonth',
    path: '/appointment-schedule/employees/:id/month/:month',
    props: true,
  },
  {
    component: AppointmentSettings,
    name: 'ClinicPanelAppointmentSettings',
    path: '/appointment-settings',
  },
  {
    component: CabinetList,
    name: 'ClinicPanelCabinetList',
    path: '/cabinets',
    props: true,
  },
  {
    component: CashboxList,
    name: 'ClinicPanelCashboxList',
    path: '/cashboxes',
  },
  {
    component: CallHistory,
    name: 'ClinicPanelCallHistory',
    path: '/call-history',
  },
  {
    component: CashboxOnlineCheckOrManual,
    name: 'ClinicPanelCashbox',
    path: '/cashbox',
  },
  {
    component: ChiefPhysicianVisitList,
    name: 'ClinicPanelChiefPhysicianVisitList',
    path: '/chief-physician/visits',
  },
  {
    component: ChiefPhysicianVisit,
    name: 'ClinicPanelChiefPhysicianVisit',
    path: '/chief-physician/visits/:id',
  },
  {
    component: CrmFunnels,
    name: 'ClinicPanelCrmFunnels',
    path: '/crm-funnels/:funnel?',
    props: (route) => ({ initialSelectedFunnel: route.params.funnel }),
  },
  {
    component: CrmDeal,
    name: 'ClinicPanelCrmDeal',
    path: '/crm-deal/:id',
  },
  {
    component: DiaryTemplateList,
    name: 'ClinicPanelDiaryTemplateList',
    path: '/diary-templates',
  },
  {
    component: DocumentGenerations,
    name: 'ClinicPanelDocumentGenerations',
    path: '/document-generations',
  },
  {
    component: EmployeeList,
    name: 'ClinicPanelEmployeeList',
    path: '/employees',
    props: true,
  },
  {
    component: FormEmployee,
    name: 'ClinicPanelFormCreateEmployee',
    path: '/employees/create',
    props: true,
  },
  {
    component: EmployeeActionHistories,
    name: 'ClinicPanelEmployeeActionHistories',
    path: '/action-history',
  },
  {
    component: EmployeeProfileBasic,
    name: 'ClinicPanelEmployeeProfileBasic',
    path: '/employees/:id/basic',
    props: true,
  },
  {
    component: EmployeeProfileAdmission,
    name: 'ClinicPanelEmployeeProfileAdmission',
    path: '/employees/:id/admission',
    props: true,
  },
  {
    component: EmployeeProfilePermissions,
    name: 'ClinicPanelEmployeeProfilePermissions',
    path: '/employees/:id/permissions',
    props: true,
  },
  {
    component: EmployeeProfileEgisz,
    name: 'ClinicPanelEmployeeProfileEgisz',
    path: '/employees/:id/egisz',
    props: true,
  },
  {
    component: EmployeeProfileWorkPlace,
    name: 'ClinicPanelEmployeeProfileWorkPlace',
    path: '/employees/:id/work-place',
    props: true,
  },
  {
    component: IntegrationList,
    name: 'ClinicPanelIntegrationList',
    path: '/integrations',
  },
  {
    component: Integration32top,
    name: 'ClinicPanelIntegration32top',
    path: '/integrations/32top',
  },
  {
    component: IntegrationFDoc,
    name: 'ClinicPanelIntegrationFDoc',
    path: '/integrations/fdoc',
  },
  {
    component: IntegrationMangoOffice,
    name: 'ClinicPanelIntegrationMangoOffice',
    path: '/integrations/mango-office',
  },
  {
    component: IntegrationProdoctorov,
    name: 'ClinicPanelIntegrationProdoctorov',
    path: '/integrations/prodoctorov',
  },
  {
    component: IntegrationChatPush,
    name: 'ClinicPanelIntegrationChatPush',
    path: '/integrations/messengers',
  },
  {
    component: IntegrationUis,
    name: 'ClinicPanelIntegrationUis',
    path: '/integrations/uis',
  },
  {
    component: MedcardMerging,
    name: 'ClinicPanelMedcardMerging',
    path: '/medcard-merging',
  },
  {
    component: NotificationPlans,
    name: 'ClinicPanelNotificationPlans',
    path: '/notification-plans',
  },
  {
    component: NotificationList,
    name: 'ClinicPanelNotificationList',
    path: '/notifications',
  },
  {
    component: PatientList,
    name: 'ClinicPanelPatientList',
    path: '/patients',
    props: true,
  },
  {
    component: PatientAdvanceDetailList,
    name: 'ClinicPanelPatientAdvanceDetailList',
    path: '/patients/:id/advance-details',
  },
  {
    component: PatientProfileAnamnesis,
    name: 'ClinicPanelPatientAnamnesis',
    path: '/patients/:id/anamnesis',
  },
  {
    component: PatientProfileAppointments,
    name: 'ClinicPanelPatientAppointments',
    path: '/patients/:id/appointments',
  },
  {
    component: PatientProfileBasic,
    name: 'ClinicPanelPatientBasic',
    path: '/patients/:id/basic',
  },
  {
    component: PatientProfileDocuments,
    name: 'ClinicPanelPatientDocuments',
    path: '/patients/:id/documents',
  },
  {
    component: WarehouseProductList,
    name: 'ClinicPanelWarehouseProductList',
    path: '/products',
  },
  {
    component: WarehouseProductArrivalList,
    name: 'ClinicPanelWarehouseProductArrivalList',
    path: '/products-arrivals',
  },
  {
    component: WarehouseProductArrival,
    name: 'ClinicPanelWarehouseProductArrival',
    path: '/products-arrivals/:arrivalId',
    props: true,
  },
  {
    component: WarehouseProductUnitList,
    name: 'ClinicPanelWarehouseProductUnitList',
    path: '/products-units',
  },
  {
    component: WarehouseProductWriteOffList,
    name: 'ClinicPanelWarehouseProductWriteOffList',
    path: '/products-writeoff',
  },
  {
    component: WarehouseProductWriteOff,
    name: 'ClinicPanelWarehouseProductWriteOff',
    path: '/products-writeoff/:writeOffId',
    props: true,
  },
  {
    component: NdflCertificateCreation,
    name: 'ClinicPanelNdflCertificateCreation',
    path: '/patients/:id/ndf-certificates/create',
  },
  {
    component: NdflCertificate,
    name: 'ClinicPanelNdflCertificate',
    path: '/ndf-certificates/:id',
  },
  {
    component: PatientProfileInvoiceList,
    name: 'ClinicPanelPatientInvoiceList',
    path: '/patients/:id/invoices',
  },
  {
    component: PatientProfileInvoice,
    name: 'ClinicPanelPatientInvoice',
    path: '/patients/:id/invoices/:invoiceId',
  },
  {
    component: PatientProfilePlanList,
    name: 'ClinicPanelPatientPlanList',
    path: '/patients/:id/plans',
  },
  {
    component: PatientProfilePlan,
    name: 'ClinicPanelPatientPlan',
    path: '/patients/:id/plans/:planId',
  },
  {
    component: PatientProfileHealthQuestionnaire,
    name: 'ClinicPanelPatientHealthQuestionnaire',
    path: '/patients/:id/questionnaire',
  },
  {
    component: PatientProfileSnapshots,
    name: 'ClinicPanelPatientSnapshots',
    path: '/patients/:id/snapshots',
  },
  {
    component: PatientProfileVisits,
    name: 'ClinicPanelPatientVisits',
    path: '/patients/:id/visits',
    props: (route) => ({ patientId: Number(route.params.id) }),
  },
  {
    component: PatientProfileVisit,
    name: 'ClinicPanelPatientVisit',
    path: '/patients/:id/visits/:visitId',
    props: true,
  },
  {
    component: FormPatient,
    name: 'ClinicPanelFormCreatePatient',
    path: '/patients/create',
    props: true,
  },
  {
    component: EmployeePayroll,
    name: 'ClinicPanelEmployeePayroll',
    path: '/payroll',
  },
  {
    component: EmployeePayrollDetails,
    name: 'ClinicPanelEmployeePayrollDetails',
    path: '/payroll-calculations/:calculationId/employees/:employeeId',
    props: ({ params: { calculationId, employeeId } }) => ({
      calculationId,
      employeeId,
    }),
  },
  {
    component: EmployeePayrollSchema,
    name: 'ClinicPanelEmployeePayrollSchema',
    path: '/employees/:id/payroll-schemas',
    props: (route) => ({ employeeId: Number(route.params.id) }),
  },
  {
    component: ServicePriceList,
    name: 'ClinicPanelServicePriceList',
    path: '/price-list',
  },
  {
    component: UserProfile,
    name: 'ClinicPanelUserProfile',
    path: '/profile',
  },
  {
    component: RegistryNdflCertificateList,
    name: 'ClinicPanelRegistryNdflCertificateList',
    path: '/registry/ndf-certificates',
    props: true,
  },
  {
    component: ReportDashboard,
    name: 'ClinicPanelReportDashboard',
    path: '/report-dashboard',
  },
  {
    component: ReportDirectionsRevenue,
    name: 'ClinicPanelReportDirectionsRevenue',
    path: '/report-directions-revenue',
  },
  {
    component: ReportPatientReturnRate,
    name: 'ClinicPanelReportPatientReturnRate',
    path: '/report-patient-return-rate',
  },
  {
    component: ReportEmployees,
    name: 'ClinicPanelReportEmployees',
    path: '/report-employees',
  },
  {
    component: ReportEmployeesPayroll,
    name: 'ClinicPanelReportEmployeesPayroll',
    path: '/report-payroll',
  },
  {
    component: ReportEmployeesWorkload,
    name: 'ClinicPanelReportEmployeesWorkload',
    path: '/report-employees-workload',
  },
  {
    component: ReportPatientAttractingCost,
    name: 'ClinicPanelReportPatientAttractingCost',
    path: '/report-patient-attracting-cost',
  },
  {
    component: ReportTreatmentPlans,
    name: 'ClinicPanelReportTreatmentPlans',
    path: '/report-treatment-plans',
  },
  {
    component: ReportCashboxes,
    name: 'ClinicPanelReportCashboxes',
    path: '/report-cashboxes',
  },
  {
    component: ReportWarehouseProductBalances,
    name: 'ClinicPanelReportWarehouseProductBalances',
    path: '/warehouse-product-balances',
  },
  {
    component: ReportPatientsAdministrators,
    name: 'ClinicPanelReportPatientsAdministrators',
    path: '/reports/patients/administrators',
  },
  {
    component: ReportSalesServices,
    name: 'ClinicPanelReportSalesServices',
    path: '/reports/sales/services',
  },
  {
    component: ReportServicesDms,
    name: 'ClinicPanelReportServicesDms',
    path: '/reports/services-dms',
  },
  {
    component: ReportSalesSources,
    name: 'ClinicPanelReportSalesSources',
    path: '/reports/sales/sources',
  },
  {
    component: EmployeeRoleList,
    name: 'ClinicPanelEmployeeRoleList',
    path: '/roles',
    props: true,
  },
  {
    component: ClinicSettings,
    name: 'ClinicPanelSettings',
    path: '/settings',
  },
  {
    component: Tariffs,
    name: 'ClinicPanelTariffs',
    path: '/tariffs',
  },
  {
    component: TaskList,
    name: 'ClinicPanelTaskList',
    path: '/tasks',
  },
  {
    component: TreatmentPlanTemplateList,
    name: 'ClinicPanelTreatmentPlanTemplateList',
    path: '/treatment-plan-templates',
  },
  {
    component: ClinicDocumentTemplateList,
    name: 'ClinicPanelClinicDocumentTemplateList',
    path: '/document-templates',
  },
  {
    component: WarehouseVendorList,
    name: 'ClinicPanelWarehouseVendorList',
    path: '/vendors',
  },
  {
    component: WaitingList,
    name: 'ClinicPanelWaitingList',
    path: '/waiting-list',
  },
  {
    component: Welcome,
    name: 'ClinicPanelWelcome',
    path: '/welcome',
  },
  {
    component: WorkSchedule,
    name: 'ClinicPanelWorkSchedule',
    path: '/work-schedule',
    props: true,
  },
  {
    component: WorkTimeAccountJournal,
    name: 'ClinicPanelWorkTimeAccountJournal',
    path: '/work-time-account-journal',
  },
  {
    component: LoyaltySystemSettings,
    name: 'ClinicPanelLoyaltySystemSettings',
    path: '/loyalty-system-settings',
  },
].map((route) => Object.assign(route, {
  meta: {
    authOf: CLINIC_AUTH,
    layout: 'clinic-panel-layout',
  },
}));

/**
 * @description Список общих маршрутов.
 * @var {any[]}
 */
const generalRoutes = [
  {
    path: '/',
    redirect: {
      name: 'Auth',
    },
  },
  {
    component: Activate,
    meta: {
      layout: 'entrance-layout',
    },
    name: 'Activate',
    path: '/activate/:id',
  },
  ...(isRemovedFeature(FORGOT_PASSWORD_FEATURE) ? [] : [{
    component: ForgotPassword,
    meta: {
      layout: 'entrance-layout',
    },
    name: 'ForgotPassword',
    path: '/forgot-password',
    props: true,
  }]),
  {
    component: Auth,
    name: 'Auth',
    meta: {
      layout: 'entrance-layout',
    },
    path: '/login',
    props: true,
  },
  {
    component: PrivacyPolicy,
    meta: {
      layout: 'empty-layout',
    },
    name: 'PrivacyPolicy',
    path: '/privacy-policy',
  },
  {
    component: ProcessingPersonalData,
    meta: {
      layout: 'empty-layout',
    },
    name: 'ProcessingPersonalData',
    path: '/soglasie-na-obrabotku-personalnyh-dannyh',
  },
  ...(isRemovedFeature(REGISTRATION_FEATURE) ? [] : [{
    component: Registration,
    meta: {
      layout: 'entrance-layout',
    },
    name: 'Registration',
    path: '/registration',
  }]),
  {
    component: ResetPassword,
    meta: {
      layout: 'entrance-layout',
    },
    name: 'ResetPassword',
    path: '/reset-password',
    props: (route) => ({ to: route.query.to }),
  },
];

export default [
  ...clinicRoutes,
  ...generalRoutes,
];
